import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    maxWidth: 700
  },
  action: {
    alignSelf: 'flex-end',
    marginTop: 12
  },
  // Override DataGrid styles
  sectionList: {
    '& .ag-body-viewport.ag-layout-auto-height .ag-center-cols-container, & .ag-body-viewport.ag-layout-auto-height .ag-center-cols-clipper': {
      minHeight: 40
    },
    '&.ag-theme-balham': {
      '& .ag-header-row:first-child .ag-header-cell ': _objectSpread({
        paddingLeft: 16,
        paddingRight: 16
      }, theme.typography.subtitle),
      '& .ag-cell': _objectSpread({}, theme.typography.body)
    }
  },
  loading: {
    '& $sectionList': {
      minHeight: 164
    }
  }
});